import { render, staticRenderFns } from "./NflTopPlayer.vue?vue&type=template&id=3afc47f8&scoped=true"
import script from "./NflTopPlayer.vue?vue&type=script&lang=js"
export * from "./NflTopPlayer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afc47f8",
  null
  
)

export default component.exports